import React, { useEffect } from "react";
import "./AccessabilityTabber.scss";
const OUTLINE_CLASS = "tab-navigation";
function onKeyDown(event) {
    if (event.key === "Tab") {
        const bodyElement = document.querySelector("body");
        if (bodyElement) {
            bodyElement.classList.add(OUTLINE_CLASS);
        }
    }
}
function onMouseDown() {
    const bodyElement = document.querySelector("body");
    if (bodyElement) {
        bodyElement.classList.remove(OUTLINE_CLASS);
    }
}
export const AccessabilityTabber = () => {
    useEffect(() => {
        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("mousedown", onMouseDown);
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("mousedown", onMouseDown);
        };
    }, []);
    return React.createElement("div", { className: "accessability-tabber" });
};
